/**
 * `orders` namespace — Korean translations.
 *
 * Mirrors `en/orders.ts` exactly; the `Record<OrdersKey, string>` annotation makes
 * a missing or misspelled key a compile error. Order-status vocabulary follows the
 * strategies glossary (체결 / 부분 체결 / 거부됨 / 만료됨). Tickers, DRY-RUN, and Live
 * stay English; BUY/SELL and MARKET/LIMIT localize to 매수·매도 / 시장가·지정가.
 */
import type { OrdersKey } from "../en/orders";

export const orders: Record<OrdersKey, string> = {
  eyebrow: "실행",
  title: "주문",
  description:
    "제출된 모든 주문을 — 모의 실행과 Live 모두 — 라이프사이클 상태 및 체결 내역과 함께 표시합니다.",

  filterAll: "전체",
  filterOpen: "진행 중",
  filterClosed: "종료",

  loadError: "주문을 불러오지 못했습니다. 다시 시도해 주세요.",
  emptyTitle: "아직 주문이 없습니다",
  emptyDescription: "전략이 낸 주문이 — 모의 실행이든 Live든 — 여기에 표시됩니다.",

  colSymbol: "종목",
  colSide: "매매",
  colType: "유형",
  colSize: "수량",
  colPrice: "가격",
  colFilled: "체결",
  colStatus: "상태",
  colPlaced: "제출 시각",
  colActions: "작업",

  loadMore: "더 보기",
  decision: "결정 근거",

  badgeDryRun: "DRY-RUN",
  badgeLive: "Live",

  sideBuy: "매수",
  sideSell: "매도",
  typeMarket: "시장가",
  typeLimit: "지정가",
  priceMarket: "시장가",

  statusFilled: "체결",
  statusPartial: "부분 체결",
  statusPending: "대기",
  statusIntent: "준비",
  statusCancelling: "취소 중",
  statusReplacing: "정정 중",
  statusCanceled: "취소됨",
  statusReplaced: "정정됨",
  statusRejected: "거부됨",
  statusCancelRejected: "취소 거부됨",
  statusReplaceRejected: "정정 거부됨",
};
